import React from 'react';
import AmazonImage from '../../assets/images/client/amazon.svg';
import GoogleImage from '../../assets/images/client/google.svg';
import LenovoImage from '../../assets/images/client/lenovo.svg';
import PaypalImage from '../../assets/images/client/paypal.svg';
import ShopifyImage from '../../assets/images/client/shopify.svg';
import SpotifyImage from '../../assets/images/client/spotify.svg';

import Client1 from '../../assets/images/sattva_clients/1.png';
import Client2 from '../../assets/images/sattva_clients/2.png';
import Client3 from '../../assets/images/sattva_clients/3.png';
import Client4 from '../../assets/images/sattva_clients/4.png';
import Client5 from '../../assets/images/sattva_clients/5.png';
import Client6 from '../../assets/images/sattva_clients/6.png';
import Client7 from '../../assets/images/sattva_clients/7.png';
import Client8 from '../../assets/images/sattva_clients/8.png';
import Client9 from '../../assets/images/sattva_clients/9.png';
import Client10 from '../../assets/images/sattva_clients/10.png';
import Client11 from '../../assets/images/sattva_clients/11.png';

const OurClientAndPartners = () => {

     const logos = [Client1, Client2, Client4, Client3, Client5, Client6, Client7, Client8, Client9, Client10, Client11];
    return (
        <section className='w-full min-h-[3vw] bg-gray-50 dark:bg-[#0F172A] pt-16'>
            <div className='flex flex-col items-center my-[2%]'>
                    <h6 className="text-blue-600 text-base font-medium uppercase mb-2">Our Clients & Partners </h6>
                </div>
            <div className="overflow-hidden py-6 mx-auto">
                <div
                    className="flex space-x-8"
                    style={{
                        animation: "scroll 20s linear infinite",
                    }}
                >
                    {/* Duplicate logos for seamless scroll */}
                    {logos.concat(logos).map((logo, index) => (
                        <div
                            key={index}
                            className="flex-shrink-0 w-36 h-36 bg-white rounded-2xl shadow-md border border-gray-100 flex items-center justify-center p-2 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                        >
                            <img src={logo} alt={`logo-${index}`} className="object-contain h-full" />
                        </div>
                    ))}
                </div>
                <style jsx>{`@keyframes scroll {0% {transform: translateX(0);}100% {transform: translateX(-50%);}}`}</style>
            </div>
        </section>
    )
}

export default OurClientAndPartners